let recherchepays = {

	navigation: document.querySelector('.recherchepays__navigation'),
	activeClass: 'is-active',
	idMap: 'map',
	pathMap: '/Content/img/destinations/world.svg',
	paddingScroll: '99px',
	heightHeader: 84,

	/// On redirige vers la lr lorsque l'on choisit une destination dans le select
	selectDestination: function (id = 'ListDestination') {
		document.getElementById(id).addEventListener('change', function () {
			if (location.pathname !== this.options[this.selectedIndex].value)
				location = this.options[this.selectedIndex].value;
		})
	},

	/// @mobile
	/// Au click sur un item zone,
	/// on centre sur l'item cliqué
	horizontalNav: function (nav) {

		let self = this;

		if (nav) {
			let navLinks = nav.querySelectorAll('a'),
				activeLink = document.querySelector(`.${self.activeClass}`)

			navLinks.forEach(function (link) {
				link.addEventListener("click", (event) => {
					navLinks.forEach(function (link) {
						link.classList.remove(self.activeClass)
					})
					link.classList.add(self.activeClass)
					link.scrollIntoView({
						behavior: "smooth",
						inline: "center"
					})
				})
			})
		}
	},

	/// @mobile
	/// au scroll sur une nouvelle zone,
	/// on toggle la classe active
	activeNav: function (nav) {
		let self = this,
			mainNavLinks = nav.querySelectorAll('a');

		window.addEventListener('scroll', event => {
			let fromTop = window.scrollY;

			mainNavLinks.forEach(link => {
				let section = document.querySelector(link.getAttribute('href')),
					pos = section.getBoundingClientRect();
				if (pos.top < self.heightHeader) {
					mainNavLinks.forEach(el => el.classList.remove(self.activeClass))
					link.classList.add(self.activeClass);
				} else if (pos.top + pos.height < fromTop) {
					link.classList.remove(self.activeClass);
				}
			});
		});
	},

	/// @desktop
	loadSvgMap: function (selector, pathCarte, idMap) {

		let self = this;

		fetch(pathCarte)
			.then(response => response.text())
			.then(svg => document.querySelector(selector).innerHTML = svg)
			.then(response => {

				// Gestion du zoom
				window.zoomTiger = svgPanZoom(selector + ' svg', {
					center: true,
					controlIconsEnabled: true,
					fit: true,
					minZoom: 1,
					zoomEnabled: true
				});

				// Gestion Desination terdav ou pas
				let carte = document.getElementById(idMap),
					pays = carte.querySelectorAll('.land');

				[].forEach.call(pays, function (el, index, array) {
					// On ajoute une classe au <path> correspondant à un pays TDV
					if (arrCodePays.includes(el.id)) {
						el.classList.add(self.activeClass);
						el.addEventListener('click', function () {
							window.location = document.querySelector(`[data-expand-link="${el.id}"]`).getAttribute('href')
						});
						el.addEventListener('mouseenter', function (el) {
							try {
								document.getElementById(idMap).querySelector('title').innerHTML = el.target.attributes.title.textContent;
							} catch (e) {
								console.error(e)
							}
						})
					}
				});
			})
	},

	/// @mobile
	/// pour gérer le menu en position fixed
	scrollPrevent: function (paddingScroll) {
		document.documentElement.style.scrollPaddingTop = paddingScroll;
	},

	init: function (arr) {
		this.selectDestination();
		let arrCodePays = arr;
		if (!helpers.isTouchDevice()) {
			this.loadSvgMap(`#${this.idMap}`, this.pathMap, this.idMap)
		} else {
			this.scrollPrevent(this.paddingScroll);
			this.horizontalNav(this.navigation);
			this.activeNav(this.navigation);
		}
	}
}

